import { TB_SUITE_LEVEL_TO_API_NAME } from 'pricing-pages-lib/utils/productsUtils';
import { useSelector } from 'react-redux';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { currentSkuIdForProductSelector, getTBSuiteProductForProductLevelSelector } from '../../../selectors/ProductsSelectors';
export const useCrmSuiteBundleSkuId = ({
  productLevel
}) => {
  const isAppReady = useGlobalLoading();
  const suiteSkuId = useSelector(state => {
    if (!isAppReady) return null;
    const product = getTBSuiteProductForProductLevelSelector(state, {
      suiteProductLevel: productLevel
    });
    const skuId = product && currentSkuIdForProductSelector(state, {
      productId: product.id
    });
    return skuId;
  });
  return suiteSkuId;
};
export const useCrmSuiteBundleApiName = ({
  productLevel
}) => {
  return TB_SUITE_LEVEL_TO_API_NAME[productLevel];
};